export default __webpack_public_path__ + "static/media/logo-dark.b11b4771.png";